import TransactionForm, {
  ITransactionFormProps,
} from "pages/receivables/partial/transactionForm/transactionForm";

// NGLS borrower flow. Not the standard receivables form.
const NglsBorrowerForm: React.FC<ITransactionFormProps> = (props) => {
  return <TransactionForm {...props} nglsFlow />;
};

export default NglsBorrowerForm;
